import React, { useEffect, useState } from "react"
import { Checkbox } from "flowbite-react";
import { differenceInDays, isBefore, parse, startOfDay } from "date-fns";
import { useContrato } from "../../../../../../../context/ContratoContext";
// import { Total } from "../../../../../../../services/data/dummyContratos";
import { useModal } from "../../../../../../../hooks/ModalContext";
import { TabelaParcelasData } from "../parcelasData";
import { useDividas } from "../../../../../../../context/DividasContext";
import { BiMinusCircle, BiPlusCircle } from "react-icons/bi";
import { Radio } from "../../../../../../generics/radio";
import { RequestParamsSimulate, useNeg } from "../../../../../../../context/NegContext";
import { Divida } from "../../../../../../../types/divida-interface";
import { Contrato } from "../../../../../../../types/contratos-data-interface";
import { ConsultaParametrosData } from "../../../../../../../types/simular-acordo-interface";
import { credoresGazin } from "../../../../../../../utils/credoresGazin";

interface ContratoDataProps {
  simulacao: ConsultaParametrosData,
  tipoNeg: string
}

export const ContratoData = ({ simulacao, tipoNeg }: ContratoDataProps) => {
  const {
    contratosData,
    getDividasWS,
    dividaData
  } = useContrato()
  const { selectedCredor, devedor, devedorCadastro } = useDividas()
  const { addParcelasNegGroup, setSelection, stateSelection, contratoNeg, addContrato, getParamsSimulate, getValores, parcelasNeg } = useNeg()
  const { setModal } = useModal();
  const [show, setShow] = useState(false)

  useEffect(() => {
    const isAP = tipoNeg === 'AP' && credoresGazin.find(item => selectedCredor?.credor_crm === item) ? true : false
    getValores(simulacao?.regrassimularacordo?.valormaximodesconto, isAP, simulacao?.regrassimularacordo?.valoratualdivida)
  }, [parcelasNeg, simulacao])

  useEffect(() => {
    setShow(false)
    setSelection('unselect')
  }, [selectedCredor])

  function selections(state: string) {
    setSelection(state)
    if (state === 'selectAll') {

      addParcelasNegGroup(dividaData)
    } else if (state === 'selectLate') {
      const parcelasNovas = dividaData.filter(item => {
        const hoje = startOfDay(new Date());
        const dataVencimento = parse(item.datvenci, 'dd/MM/yyyy', new Date());
        return isBefore(dataVencimento, hoje);
      }
      )
      addParcelasNegGroup(parcelasNovas)
    } else {
      addParcelasNegGroup([], true)
      addContrato({} as Contrato)
    }
  }

  async function checkedContrato(cpf_cnpj: string, codcredor: string, contrato: string, isCheck?: boolean) {
    if (isCheck && show) {
      setShow(true)
      return
    }
    if (dividaData?.length <= 0) {
      const d = await getDividasWS({ codcredor, contrato, cpf_cnpj, url: selectedCredor.url_ws })
      setSelection('selectAll')
      addParcelasNegGroup(d)
      const params: RequestParamsSimulate = {
        tipo: 'AV',
        url: selectedCredor.url_ws,
        codcredor: String(selectedCredor.credor_crm),
        cpf_cnpj: devedorCadastro?.cpfcnpj,
        contratos: d.map(p => {
          return {
            idparcial: p.idparcial,
            numcontrato: p.contrato,
            valpago: p.valorpago,
            filial: p.filial,
            datvenci: p.datvenci,
            numeroparcela: p.numeroparcela
          }
        })
      }
      await getParamsSimulate(params)
    }
    setShow(!show)
  }

  async function contratoChecked(c: Contrato) {
    if (!contratoNeg.numcontrato) {
      setSelection('selectAll')
      if (!show) {
        addParcelasNegGroup(dividaData)
      }



    } else {
      setSelection('unselect')
      addParcelasNegGroup([], true)
    }
    addContrato(c)
    await checkedContrato(devedor.cpf_cnpj || '', c.codcredor, c.numcontrato, true)
    if (!contratoNeg.numcontrato && c.permiteacordo) setModal('AVISO', 'Aviso', false, true)
    if (show) {
      setShow(true)
      return
    }
  }

  function formatDate(date: string) {
    const [dia, mes, ano] = date.split('/')
    return `${mes}/${dia}/${ano}`
  }
  return (<>
    {
      contratosData?.contratos?.length > 0 && contratosData.contratos.map(c => (
        <div key={c.numcontrato} className={`mb-4 rounded-md bg-white `}>
          <div className="flex w-full rounded-md border border-gray-400 pr-2">
            <div
              className={`mr-2 w-2 rounded-l-md ${c.permitedivida ? " bg-green-500" : " bg-red-500"
                } `}
            ></div>
            <div className="w-full py-2">
              <div className="">
                <div className="my-2 flex items-center justify-between text-sm">
                  <div className="flex items-center ">
                    <Checkbox
                      color="green"
                      className="mr-2 bg-primary"
                      onChange={() => {
                        contratoChecked(c)
                      }}
                      checked={c.numcontrato === contratoNeg?.numcontrato ? true : false}
                    />
                    <strong className="font-medium text-xs text-gray-600">
                      Contrato: {c.numcontrato}
                    </strong>
                  </div>
                  {/* checked={} onChange={() => setRenda(!renda)} */}
                  {
                    c.permiteacordo && <div className="flex h-fit items-center p-1 rounded-md gap-1  bg-purple-100 ">
                      <p className="font-semibold text-purple-800">Acordo vigente</p>
                    </div>
                  }

                  <p className="font-medium text-xs text-gray-600">
                    Dias em atraso:
                    <strong className="ml-1">
                      {differenceInDays(new Date(), new Date(formatDate(c.vencimento)))}
                    </strong>
                  </p>


                  <button
                    className="text-lg font-bold"
                    onClick={() => {
                      if (!show) {
                        setShow(true)
                      }
                      checkedContrato(devedor.cpf_cnpj || '', c.codcredor, c.numcontrato)
                      // showParcelasContrato(c.numcontrato);

                    }}
                  >
                    {
                      show ?
                        <BiMinusCircle size={24} className="fill-primary" /> : <BiPlusCircle size={24} className="fill-primary" />
                    }
                  </button>
                </div>
              </div>

              <div
                className={`${!show && dividaData && "hidden"
                  } `}
              >
                <>

                  <div>
                    <div className="flex  gap-4 mb-4">
                      <Radio name="checkContrato" sizeText="text-xs" label=" Selecionar todos" checked={stateSelection === 'selectAll'} onChange={() => {
                        selections('selectAll')
                        if (!contratoNeg.numcontrato) {
                          addContrato(c)
                        }
                      }} />
                      <Radio name="checkContrato" sizeText="text-xs" label="Selecionar vencidos" checked={stateSelection === 'selectLate'} onChange={() => {
                        selections('selectLate')
                        if (!contratoNeg.numcontrato) {
                          addContrato(c)
                        }

                      }} />
                      <Radio name="checkContrato" sizeText="text-xs" label="Desmarcar Todos" checked={stateSelection === 'unselect'} onChange={() => selections('unselect')} />
                    </div>
                  </div>

                  {
                    dividaData && dividaData.length > 0 && <TabelaParcelasData prestacoes={dividaData} tipoNeg={tipoNeg} />
                  }


                  {/* <div className="flex w-full items-center bg-gray-100 p-2 text-xs font-medium">
                    <div className="grid w-full grid-cols-[150px_50px_50px_50px] place-content-center gap-2">
                      <p></p>
                      <p className=" text-center text-gray-800 underline">
                        Min
                      </p>
                      <p className=" text-center text-gray-800 underline">
                        Max
                      </p>
                      <p></p>
                      <p>% Desconto valor principal:</p>
                      <input
                        type="text"
                        className="h-6 w-12 bg-gray-200 px-2 text-center placeholder:text-gray-800 "
                        placeholder={`${simulacao?.regrassimularacordo?.percentual_desconto_min}`}
                        disabled
                      />
                      <input
                        type="text"
                        className="h-6 w-12 bg-gray-200 px-2 text-center placeholder:text-gray-800 "
                        placeholder={`${simulacao?.regrassimularacordo?.percentual_desconto_max}`}
                        disabled
                      />
                      <input
                        type="text"
                        className="h-6 w-12 border border-gray-200 bg-white px-2 "

                      />
                      <p>% Desconto juros:</p>
                      <input
                        type="text"
                        className="h-6 w-12 bg-gray-200 px-2 text-center placeholder:text-gray-800 "
                        placeholder={`${simulacao?.regrassimularacordo?.percentual_isencaojuros_min}`}
                        disabled
                      />
                      <input
                        type="text"
                        className="h-6 w-12 bg-gray-200 px-2 text-center placeholder:text-gray-800 "
                        placeholder={`${simulacao?.regrassimularacordo?.percentual_isencaojuros_max}`}
                        disabled
                      />
                      <input
                        type="text"
                        className="h-6 w-12 border border-gray-200 bg-white px-2 "

                      />
                    </div>

                    <div className="grid w-full grid-cols-[150px_50px_50px_50px] place-content-center gap-2">
                      <p></p>
                      <p className=" text-center text-gray-800 underline">
                        Min
                      </p>
                      <p className=" text-center text-gray-800 underline">
                        Max
                      </p>
                      <p></p>
                      <p>% Desconto valor multa:</p>
                      <input
                        type="text"
                        className="h-6 w-12 bg-gray-200 px-2 text-center placeholder:text-gray-800 "
                        placeholder={`${simulacao?.regrassimularacordo?.percentual_isencaomulta_min}`}
                        disabled
                      />
                      <input
                        type="text"
                        className="h-6 w-12 bg-gray-200 px-2 text-center placeholder:text-gray-800 "
                        placeholder={`${simulacao?.regrassimularacordo?.percentual_isencaomulta_max}`}
                        disabled
                      />
                      <input
                        type="text"
                        className="h-6 w-12 border border-gray-200 bg-white px-2 "

                /> 
                      <p>% Desconto outras taxas:</p>
                      <input
                        type="text"
                        className="h-6 w-12 bg-gray-200 px-2 text-center placeholder:text-gray-800 "
                        placeholder={`${simulacao?.regrassimularacordo?.percentual_desconto_min}`}
                        disabled
                      />
                      <input
                        type="text"
                        className="h-6 w-12 bg-gray-200 px-2 text-center placeholder:text-gray-800 "
                        placeholder={`${simulacao?.regrassimularacordo?.percentual_desconto_max}`}
                        disabled
                      />
                      <input
                        type="text"
                        className="h-6 w-12 border border-gray-200 bg-white px-2 "

                      /> 
                    </div> 
                  </div> */}
                </>

              </div>
            </div>
          </div>
        </div>
      )


      )
    }
  </>)
}